import { Component, OnInit, inject } from '@angular/core';
import { LdwRouterService } from '../../route/ldw-router.service';
import { DocumentHelper } from '../../shared/helpers/document-helper';
import { LDWDocument } from '../../shared/models/LDWDocument';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from '../../shared/services/document.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentChanges } from '../../shared/models/document-changes';
import { InfoService } from '../../shared/services/info.service';
import { SettingsService } from '../../shared/settings/settings.service';

@Component({
    selector: 'ldw-document-changes-page',
    templateUrl: './document-changes-page.component.html',
    styleUrls: ['./document-changes-page.component.css'],
    standalone: false
})
export class DocumentChangesPageComponent implements OnInit {
  private dialog = inject(MatDialog);
  private routerService = inject(LdwRouterService);
  private documentService = inject(DocumentService);
  private translate = inject(TranslateService);
  private infoService = inject(InfoService);
  private route = inject(ActivatedRoute);
  private settingsService = inject(SettingsService);

  document: LDWDocument | undefined = undefined;
  changes: DocumentChanges[] | [] = [];
  documentHelper: DocumentHelper;
  displayedColumns: string[] = ['dateTime', 'user', 'action'];

  constructor() {
    const dialog = this.dialog;
    const routerService = this.routerService;
    const translate = this.translate;

    this.documentHelper = new DocumentHelper(dialog, routerService, translate);
    this.infoService.clearStatus();
  }

  ngOnInit(): void {
    const docid = this.route.snapshot.paramMap.get('docid');
    if (docid == undefined) {
      this.documentHelper.documentNotFound(undefined);
      return;
    }

    this.documentService.getDocument(docid).subscribe(
      (value) => (this.document = value),
      (error) => this.error(docid, error)
    );

    this.documentService.getDocumentChanges(docid).subscribe(
      (value) => {
        this.changes = value;
        this.infoService.setLoadedItems(this.changes.length);
      },
      (error) => this.error(docid, error)
    );
  }

  error(docid: string, error: any) {
    this.documentHelper.documentNotFound(docid);
    console.log(error);
  }

  get viewVisible(): boolean {
    return this.document != undefined && this.document.id != '';
  }

  close() {
    this.routerService.navigateBack();
  }
  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
